import { render, staticRenderFns } from "./MailConfirmationSend.vue?vue&type=template&id=7ad1b2a7&scoped=true"
import script from "./MailConfirmationSend.vue?vue&type=script&lang=js"
export * from "./MailConfirmationSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad1b2a7",
  null
  
)

export default component.exports